import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import WithApa from 'newComponents/WithApa/WithApa';
import './ModalPassword.scss';
import {
  digitsValidator,
  Form,
  minLengthValidator,
  Modal,
  specialCharValidator,
  upperAndLowerCaseValidator,
} from 'cvlib';
import {
  hideModalPassword,
  resetPassword,
  showPasswordFormModal,
} from 'action-creators/reset-password';
import * as R from 'ramda';
import { FaTimes } from 'react-icons/fa';
import { getCheckToken } from 'services/api/user/checktoken';
import { GetRegion } from 'constants';
import { useNavigate } from 'react-router-dom';
import useMenuRedirect from 'containers/Menu/hooks/useMenuRedirect';
import { useMetrics } from 'hooks/metrics/useMetrics';

const ModalPassword = props => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { modalVisibility, tokenPass, showNewPasswordForm, successPasswordChanged } = useSelector(state => state.resetPassword);
  const assets = useSelector(state => state.asset);
  const [newPassword, setNewPassword] = useState();
  const [showErrorAsNeutral, setShowErrorAsNeutral] = useState(true);
  const { firstNode } = useMenuRedirect();
  const { buildMetricsEvent, sendMetricsEvent } = useMetrics();

  // useEffect(
  //   () => {
  //     const checkToken = async () => {
  //       try {
  //         const response = await getCheckToken({ token: tokenPass.token });
  //       } catch (error) {
  //         navigate(`${GetRegion()}/${firstNode}`);
  //       }
  //     };
  //     if (tokenPass && tokenPass.token) {
  //       checkToken();
  //     }
  //   },
  //   [tokenPass],
  // );

  useEffect(
    () => {
      if (successPasswordChanged) {
        setTimeout(() => {
          dispatch(hideModalPassword());
        }, 3000);
      }
    },
    [successPasswordChanged],
  );

  const {
    newPassword_alert_title_label,
    newPassword_alert_description_label,
    newPassword_alert_option_button_createPassword,
    newPassword_alert_option_button_createLater,
    password_tooltip_completeField_label_validation,
    password_tooltip_title_label,
    password_tooltip_letter_label_validation,
    password_tooltip_number_label_validation,
    password_tooltip_length_label_validation,
    password_tooltip_specialCharacters_label_validation,
    newPassword_notification_title_label,
    newPassword_modal_option_button_createPassword,
    newPassword_modal_title_label,
  } = props.translations;

  const {
    generic_tooltip_pattern_checkmark_yes,
    generic_tooltip_pattern_checkmark_no,
    mail_modal_icon_confirm,
  } = props.asset;

  const satisfyPassword = R.allPass([
    upperAndLowerCaseValidator,
    minLengthValidator(8),
    digitsValidator,
    R.allPass([R.complement(specialCharValidator), minLengthValidator(1)]),
  ]);

  const modalElements = [
    {
      element: 'title',
      content: newPassword_alert_title_label,
      position: 'top',
    },
    {
      element: 'subtitle',
      content: newPassword_alert_description_label,
      position: 'top',
      style: { fontSize: '1rem', marginTop: '5px' },
    },
    {
      element: 'button',
      position: 'top',
      style: { margin: '15px 0'},
      expand: 1,
      content: newPassword_alert_option_button_createPassword,
      submit: () => {
        const event = buildMetricsEvent('change_password', {
          content_section: 'inicia sesion',
          interaction_type: 'crear contraseña',
          modulo_name: 'nueva contraseñá',
        })
        sendMetricsEvent(event);

        sessionStorage.removeItem('changePasswordModal');
        dispatch(showPasswordFormModal());
      },
      type: 'red',
    },
    {
      element: 'button',
      type: 'gray',
      position: 'top',
      expand: 0.2,
      content: newPassword_alert_option_button_createLater,
      onClick: () => {
        const event = buildMetricsEvent('change_password', {
          content_section: 'inicia sesion',
          interaction_type: 'crear en otro momento',
          modulo_name: 'nueva contraseñá',
        })
        sendMetricsEvent(event);

        sessionStorage.removeItem('changePasswordModal');
        dispatch(hideModalPassword());
      },
    },
  ];

  const passwordFormElements = [
    {
      element: 'message',
      content: `<img src="${
        assets.playingLive_access_general_icon_exit
      }" width="16px" height="16px" />`,
      style: {
        position: 'absolute',
        right: 10,
        top: 10,
        width: 16,
        height: 16,
        cursor: 'pointer',
      },
      onMouseDown: () => dispatch(hideModalPassword()),
    },
    {
      element: 'title',
      content: newPassword_modal_title_label,
      position: 'top',
      style: { fontSize: '1.5rem', marginTop: '60px', marginBottom: '40px' },
    },
    {
      element: 'item',
      type: 'password',
      name: 'password',
      id: 'password',
      autoFocus: true,
      expand: 2,
      defaultVisible: true,
      header: password_tooltip_title_label,
      successIcon: generic_tooltip_pattern_checkmark_yes,
      errorIcon: generic_tooltip_pattern_checkmark_no,
      message: {
        upperAndLower: password_tooltip_letter_label_validation,
        digits: password_tooltip_number_label_validation,
        minLength: password_tooltip_length_label_validation,
        specialChar:
          password_tooltip_specialCharacters_label_validation ||
          'password_tooltip_specialCharacters_label_validation',
      },
      registerOptions: {
        required: password_tooltip_completeField_label_validation,
      },
      onChange: ({ target }) => {
        setNewPassword(target.value);
        setShowErrorAsNeutral(true);
      },
      showErrorAsNeutral,
    },
    {
      element: 'button',
      type: 'red',
      content: newPassword_modal_option_button_createPassword,
      style: { marginBottom: '110px', marginTop: '30px' },
      submit:
        satisfyPassword(newPassword) === true
          ? async () => {
            try {
              await dispatch(
                resetPassword({
                  password: newPassword,
                  confirm_password: newPassword,
                  token: tokenPass.token,
                }),
              );

              const event = buildMetricsEvent('new_password', {
                content_section: 'inicia sesion',
                interaction_type: 'crear',
                modulo_name: 'crear nueva contraseña',
              });
              sendMetricsEvent(event);
            } catch (error) {
              console.log(error)
            }
            }
          : () => setShowErrorAsNeutral(false),
      dimmed: !satisfyPassword(newPassword),
    },
  ];

  return (
    <Modal isOpen={modalVisibility}>
      {!successPasswordChanged && (
        <Form
          elements={showNewPasswordForm ? passwordFormElements : modalElements}
          classes={showNewPasswordForm ? ['ModalPassword'] : ['ModalElement']}
        />
      )}
      {successPasswordChanged && (
        <div className={'SuccessModal'}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'flex-end',
            }}
          >
            <FaTimes
              style={{ cursor: 'pointer', color: 'white' }}
              onClick={() => dispatch(hideModalPassword())}
            />
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              style={{ width: '60px', height: '60px' }}
              src={mail_modal_icon_confirm}
              alt="mail_modal_icon_confirm"
            />
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
            }}
          >
            <h1>{newPassword_notification_title_label}</h1>
          </div>
        </div>
      )}
    </Modal>
  );
};

ModalPassword.propTypes = {
  translations: PropTypes.shape({}),
  asset: PropTypes.shape({}),
};

export default WithApa(ModalPassword);
